import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./GuestFooter.module.css";

/** Diskreter Hinweis am Ende der Gast- und User-Ansichten:
 * „Diese Liste ist werbefrei, finanziert durch PRO-Nutzer:innen."
 * Konvertiert Teilnehmer beilaeufig zu neuen Organisator:innen, ohne
 * sich aufzudraengen. */
export function GuestFooter() {
  const { t } = useTranslation();
  return (
    <p className={styles.note}>
      <span>{t("guestFooter.text")}</span>{" "}
      <Link to="/how-it-works" className={styles.link}>
        {t("guestFooter.link")}
      </Link>
    </p>
  );
}
